var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseButtonSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#D8E5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.63896 11.3606C4.43277 11.1545 4.43277 10.8202 4.63896 10.614L10.6123 4.64065C10.8185 4.43446 11.1528 4.43446 11.359 4.64065C11.5651 4.84683 11.5651 5.18113 11.359 5.38731L5.38562 11.3606C5.17944 11.5668 4.84514 11.5668 4.63896 11.3606Z",
    fill: "#2A374E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.63896 4.64034C4.84514 4.43415 5.17944 4.43415 5.38562 4.64034L11.359 10.6137C11.5651 10.8198 11.5651 11.1541 11.359 11.3603C11.1528 11.5665 10.8185 11.5665 10.6123 11.3603L4.63896 5.387C4.43277 5.18082 4.43277 4.84653 4.63896 4.64034Z",
    fill: "#2A374E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButtonSvg);
export default __webpack_public_path__ + "static/media/CloseButtonSvg.e3459dbdb96a0fa2c2546d5f2d904ce7.svg";
export { ForwardRef as ReactComponent };